module.exports = __webpack_public_path__ + "img/item13.6c5f34f8.png";